const PN_KEY = 'current_pn'

/**
 * 获取当前业务 PN
 *
 * 注意：
 * 这里没有默认 p000！
 *
 * p000 只允许 authorizationWebsite/enabled 使用
 */
export function getPn() {
    return localStorage.getItem(PN_KEY) || ''
}

/**
 * 保存当前业务 PN
 */
export function setPn(pn) {
    if (!pn) {
        return
    }

    localStorage.setItem(PN_KEY, pn)
}

/**
 * 清除当前 PN
 */
export function removePn() {
    localStorage.removeItem(PN_KEY)
}
